import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { getParentOrSelfWithClass } from '../../../libs/gin-tonic/helpers/dom/get-parent-or-self-with-class';

@Component({ className: 'js-hamburger' })
export class HamburgerComponent {
	private toggleClass = 'is-active';
	private parentToggleClass = 'is-visible';

	constructor(private element: HTMLElement) {
		const hamburgerButton = this.element.getElementsByClassName('js-hamburger-toggler');
		const parentElem = getParentOrSelfWithClass(this.element, 'js-magic-scroll-toggle-visibility');

		if (hamburgerButton && hamburgerButton.length) {
			hamburgerButton[0].addEventListener('click', () => {
				this.element.classList.toggle(this.toggleClass)
				if (parentElem != null) {
					parentElem.classList.toggle(this.parentToggleClass)
				}
			});
		}
	}
}
